const BUCKET_ORDER = ['today', 'yesterday', 'previous7Days', 'earlier'];
const startOfDay = d => {
  const out = new Date(d);
  out.setHours(0, 0, 0, 0);
  return out;
};
const isSameDay = (a, b) => {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
};
export const bucketFor = (updatedAt, now = Date.now()) => {
  const nowDate = new Date(now);
  const target = new Date(updatedAt);
  if (isSameDay(nowDate, target)) {
    return 'today';
  }
  const yesterday = new Date(nowDate);
  yesterday.setDate(yesterday.getDate() - 1);
  if (isSameDay(yesterday, target)) {
    return 'yesterday';
  }
  const sevenDaysAgo = startOfDay(nowDate);
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  if (target.getTime() >= sevenDaysAgo.getTime()) {
    return 'previous7Days';
  }
  return 'earlier';
};
export const groupByTimeBucket = (rows, now = Date.now()) => {
  const map = new Map();
  for (const row of rows) {
    const b = bucketFor(row.updatedAt, now);
    const existing = map.get(b);
    if (existing) {
      existing.push(row);
    } else {
      map.set(b, [row]);
    }
  }
  const result = [];
  for (const bucket of BUCKET_ORDER) {
    const bucketRows = map.get(bucket);
    if (bucketRows && bucketRows.length > 0) {
      result.push({
        bucket,
        rows: bucketRows
      });
    }
  }
  return result;
};